import { Field, Float, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'

@InputType()
export class OrderItemUpdateOriginalPriceArgs extends ActionArgs {
  @Field(() => String)
  itemId: string

  @Field(() => String)
  productId: string

  @Field(() => Float)
  originalPrice: number

  @Field(() => String)
  orderId: string

  @Field(() => Float)
  quantity: number

  @Field(() => Boolean, { nullable: true })
  changeOriginalPrice?: boolean
}
